$(document).ready(function(){
  AOS.init();

  // Header drawer js
  $(document).on('click', '.drawer_tab', function(){
    var data_link = $(this).attr('data-link');
    $(this).addClass('active').siblings().removeClass('active');
    $('.menu-drawer_menu .child_menu').each(function(){
     var data_handle = $(this).attr('data-handle');
      if(data_handle == data_link){
        $(this).addClass('active');
      }else{
        $(this).removeClass('active');
      }
    });
  });
$(document).on('click', '.footer-block',function(){
 let $this = $(this);
    if ($this.hasClass('active')) {
       $(this).removeClass('active');
       $this.find('footer-accordion-text').slideUp(350);
    }
  else{
    $('.footer-block').removeClass('active');
    $(this).addClass('active');
    $this.find('footer-accordion-text').slideDown(350);
     
  }
}); 
});
 
   var full_des = $(document).find('.full_description').html();
   setTimeout(function() {
    var note_pera = $(document).find('.product__description p:last').html();
    if(note_pera.includes('Note')) {
       $(document).find('.short_description').append(note_pera);
     }
     else{
      
       $(document).find('.short_description').css('display', 'none');
     }
    }, 1000);

$(document).on('click', '.custom-product-count span',function(){
  var selectedCount = $(this).data('value');
   fetch(`/cart/update.js`, {
    body: JSON.stringify({
      attributes: { collection_products_per_page: selectedCount },
    }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then((response) => {
      location.reload();
  });
})
$(document).on('click', '.itg_popup_close',function(){
  $(document).find('.itg_popup_wr').removeClass('visible');
   $("body").css("overflow", "auto");
})